import ClearIcon from "@mui/icons-material/Clear";
import { Box, IconButton, InputAdornment, TextField, Typography } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { hubAction } from "redux/slice/hub";
import ScrollToBottom from "utils/ScrollToBottom";
import Insight from "./Insight";

const Insights = ({ user, insights, isMobileDisplay }) => {
  const dispatch = useDispatch();
  const bottomRef = useRef(null);
  const isInitialLoad = useRef(true);
  const containerRef = useRef(null);

  const [filterText, setFilterText] = useState("");
  const [filteredInsights, setFilteredInsights] = useState(insights);

  const scrollToBottom = () => {
    bottomRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    if (isInitialLoad.current && insights && insights.length > 0) {
      bottomRef.current?.scrollIntoView({ behavior: "auto", block: "nearest" });
      isInitialLoad.current = false;
    }
  }, [insights]);

  useEffect(() => {
    dispatch(hubAction.removeNotifications({ key: "insights" }));
  }, []);

  const handleFilterChange = (event) => {
    setFilterText(event.target.value.toLowerCase());
  };

  useEffect(() => {
    setFilteredInsights(
      insights.filter((insight) => insight.displayMessage.toLowerCase().includes(filterText))
    );
  }, [filterText]);

  const handleClearFilter = () => {
    setFilterText("");
  };

  return (
    <>
      <Box className="insight-filter-container">
        <TextField
          variant="outlined"
          placeholder="Filter alerts..."
          value={filterText}
          onChange={handleFilterChange}
          sx={{
            "& .MuiInputBase-root": { color: "#ddd9d5", backgroundColor: "#252525" },
            "& .MuiInputLabel-root": {
              color: "#ddd9d5",
              "&.Mui-focused": {
                color: "#ddd9d5",
              },
            },
            "& .MuiOutlinedInput-notchedOutline": { borderColor: "#ddd9d5" },
            "& .MuiOutlinedInput-input": { color: "#ddd9d5" },
            "& .MuiIconButton-root": { color: "#ddd9d5" },
            "&:hover .MuiOutlinedInput-notchedOutline": {
              borderColor: "#ddd9d5",
            },
            "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderColor: "#ddd9d5",
            },
          }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={handleClearFilter} size="small">
                  <ClearIcon />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </Box>
      <Box ref={containerRef} className="hub-content-window">
        {filteredInsights && filteredInsights.length > 0 ? (
          filteredInsights.map((insight) => (
            <Box key={insight.id}>
              <Insight
                user={user}
                insight={insight}
                handleMute={() =>
                  dispatch(
                    hubAction.handleInsightMute({
                      insightId: insight.id,
                      newValue: !insight.muted,
                    })
                  )
                }
              />
            </Box>
          ))
        ) : (
          // <TableContainer
          //   component={Paper}
          //   sx={{
          //     boxShadow: "none",
          //     borderRadius: 0,
          //   }}
          // >
          //   <Table
          //     aria-label="simple table"
          //     sx={{
          //       maxHeight: window.innerHeight < 800 ? 320 : 450,
          //       userSelect: "none",
          //     }}
          //   >
          //     <TableHead sx={{ display: "table-header-group" }}>
          //       <TableRow>
          //         <TableCell>Alert</TableCell>
          //         <TableCell>Current Status</TableCell>
          //       </TableRow>
          //     </TableHead>
          //     <TableBody>
          //       {insights.map((insight) => (
          //         <TableRow key={insight.id}>
          //           <Insight
          //             insight={insight}
          //             handleMute={() =>
          //               dispatch(
          //                 hubAction.handleInsightMute({
          //                   insightId: insight.id,
          //                   newValue: !insight.muted,
          //                 })
          //               )
          //             }
          //           />
          //         </TableRow>
          //       ))}
          //     </TableBody>
          //   </Table>
          // </TableContainer>
          <Typography sx={{ textAlign: "left", fontSize: "1rem", ml: "2rem", mt: "1rem" }}>
            No insights to display
          </Typography>
        )}
        <Box ref={bottomRef} />
        <ScrollToBottom
          containerRef={containerRef}
          onClick={() => scrollToBottom(bottomRef)}
          isMobileDisplay={isMobileDisplay}
        />
      </Box>
    </>
  );
};

export default Insights;
